import { render, staticRenderFns } from "./ItemTimelineTransaction.vue?vue&type=template&id=a8d63570&scoped=true&"
import script from "./ItemTimelineTransaction.vue?vue&type=script&lang=js&"
export * from "./ItemTimelineTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d63570",
  null
  
)

export default component.exports